module.exports = __webpack_public_path__ + "media/img/forkme-78144b855f3541d70c2931d77bd63ad2.png";